import { take, call, put, fork, all } from 'redux-saga/effects'
import { hashHistory } from 'react-router'

import fetchApi from '../../../../../utils/fetchApi'
import Configs from '../../../../../constants/Config'


function* getUserFlow() {
  const INFINITE = true

  while (INFINITE) {
    const {
      payload: { id },
      next
    } = yield take('GET_USER')
    yield put({ type: 'CLEAR_USER_STATE' })
    try {
      const response = yield call(fetchApi, `Accounts/${id}`)
      if (response && !response.error) {
        yield put({
          type: 'GET_USER_SUCCESS',
          payload: response
        })
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}


function* editUserFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload: {payload}, next } = yield take('EDIT_USER');
		try {
			const response = yield call(fetchApi, `accounts/${payload.id}`, payload.data, { method: 'PATCH' });

			if (response && !response.error) {
				yield put({
					type: 'EDIT_USER_SUCCESS',
					payload: response
				});
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

export function* userDetailFlow() {
  yield fork(getUserFlow)
  yield fork(editUserFlow)
}



// WEBPACK FOOTER //
// ./routes/admin/routes/users/saga/userDetail.js